export interface PhysicalDeviceInformation {
  readonly authenticationMethods: string[];
  readonly authenticationUiType: string;
  readonly deviceBrand: string;
  readonly deviceImage: string;
  readonly deviceModel: string;
  readonly deviceType: string;
  readonly installedClientApplicationTypes: string[];
  readonly operationMode: string;
  readonly physicalDeviceId: string;
  readonly securityLevel: string;
  readonly serialNumber: string;
  readonly supportedTwoFaTypes: string[];
}
